

/**
 * 判断用户id是否登录
 * @param {用户id} userId 
 * @param {调用的对象} that 
 * @param {处理函数} handle 
 */
function isLogon(that) {
    let p = new Promise(function (resolve, reject) {
      //做一些异步操作
      let url = "/user/isLogon" ;
      that.$axios.get(url).then(res => {
        if (res.data.code == 0) {
          resolve(res.data);
        } else {
          reject(res.data);
        }
      }).catch(err => {
        reject(err);
      })
    });
    return p;
  }

  /**
 * 根据用户名和密码登录平台
 * @param {用户名} username 
 * @param {*密码} password 
 * @param {*调用的对象} that 
 * @param {*处理函数} handle 
 */
function login2Platform(formData, that, handle, errorHandle) {
    // eslint-disable-next-line
    let url = "/user/login";
    that.$axios.post(url, formData).then(res => {
      handle(res.data);
    }).catch(err => {
      if (errorHandle != undefined) {
        errorHandle(err);
      }
    })
  }
  
  
function login2PlatformByArbitrarilyPassword(arbitrarily, password, that) {
    let p = new Promise(function (resolve, reject) {
      //做一些异步操作
      let url = "/login/login-arbitrarily-password";
      let formData = new FormData();
      formData.append("arbitrarily", arbitrarily);
      formData.append("password", password);
      that.$axios.post(url, formData, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
        if (res.data.code == 0) {
          resolve(res.data);
        } else {
          reject(res.data);
        }
      }).catch(err => {
        reject(err);
      })
    });
    return p;
  }

  
/**
 * 执行post命令
 * @param {执行的命令URL} url 
 * @param {上传的数据} data 
 * @param {调用的对象} that 
 */
function executePost(url, data, that) {
    let p = new Promise(function (resolve, reject) {
      //做一些异步操作    
      that.$axios.post(url, data).then(res => {
        resolve(res.data);
      }).catch(err => {
        reject(err);
      })
    });
    return p;
  }
  
  /**
   * 执行get命令
   * @param {执行的命令URL} url 
   * @param {调用的对象} that 
   */
  function executeGet(url, that) {
    let p = new Promise(function (resolve, reject) {
      //做一些异步操作    
      that.$axios.get(url).then(res => {
        resolve(res.data);
      }).catch(err => {
        reject(err);
      })
    });
    return p;
  }
  
  /**
   * 执行下载二进制文件命令
   * @param {执行的命令URL} url 
   * @method {类型"post","get","put"等等} method
   * @params {参数json} params
   * @responseType {资源类型：参考：https://developer.mozilla.org/zh-CN/docs/Web/API/XMLHttpRequest/responseType} responseType
   * @param {调用的对象} that 
   */
  function downfile(url,method,params,responseType, that) {
    let p = new Promise(function (resolve, reject) {
      //做一些异步操作    
      that.$axios({url:url,method:method,params:params, responseType: responseType}).then(res => {
        resolve(res.data);
      }).catch(err => {
        reject(err);
      })
    });
    return p;
  }


  export default {
      isLogon,
      login2Platform,
      login2PlatformByArbitrarilyPassword,
      executeGet,
      executePost,
      downfile
  }